import localhostErrorNoAuthImg from "../../../../assets/images/facebook-localhost/localhost-error-noauth.png";
import hidingBeforeImg from "../../../../assets/images/facebook-localhost/localhost-error.png";
import * as React from 'react';
export default {
  localhostErrorNoAuthImg,
  hidingBeforeImg,
  React
};